import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import TourTodoContainer from './TourTodoContainer';

import LodgingWidget from './widgets/LodgingWidget';
import MapWidget from './widgets/MapWidget';
import RosterWidget from './widgets/RosterWidget';
import RoutingWidget from './widgets/RoutingWidget';
import TodayWidget from './widgets/TodayWidget';
import TourManagerWidget from './widgets/TourManagerWidget';

class TourOverviewTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
    };
    this.onDropRoute = this.onDropRoute.bind(this);
    this.onDropRoster = this.onDropRoster.bind(this);
    this.clearRoute = this.clearRoute.bind(this);
  }
  componentWillMount() {
    console.log('In TourOverviewTab.componentWillMount() ');
  }

  onDropRoute(acceptedFiles) {
    this.setState({
      files: acceptedFiles,
    });
    this.props.importRoute(this.props.tour.id, acceptedFiles);
  }
  onDropRoster(acceptedFiles) {
    this.setState({
      files: acceptedFiles,
    });
    this.props.importRoster(this.props.tour.id, acceptedFiles);
  }
  onOpenClick() {
    this.dropzone.open();
  }
  clearRoute() {
    this.props.clearRoute(this.props.tour.id);
  }

  render() {
    const showMap = this.props.tour.tour_stops.length !== 0;

    return (
      <div>
        <div className="row navtabs-overview-wrapper">
          <TourTodoContainer tour={this.props.tour} />
          <RoutingWidget
            tour={this.props.tour}
            onDrop={this.onDropRoute}
            isProcessing={this.props.routeIsProcessing}
            clearRoute={this.clearRoute}
            readOnly={this.props.readOnly}
          />
          <RosterWidget
            tour={this.props.tour}
            onDrop={this.onDropRoster}
            readOnly={this.props.readOnly}
            isProcessing={this.props.rosterIsProcessing}
          />
          <TourManagerWidget
            tour={this.props.tour}
            readOnly={this.props.readOnly}
            addMember={this.props.addMember}
            dispatchRemoveMemberFromGroup={this.props.dispatchRemoveMemberFromGroup}
            duplicateMemberError={this.props.duplicateMemberError}
          />
        </div>
        <div className="row">
          { showMap && (
            <MapWidget tour={this.props.tour} />
          )}

        </div>
      </div>
    );
  }
}

TourOverviewTab.propTypes = {
  tour: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag_line: PropTypes.string.isRequired,
    image: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    created_on: PropTypes.string,
    updated_on: PropTypes.string,
    state: PropTypes.string.required,
    sent_to_manager: PropTypes.string,
    travel_agency: PropTypes.number,
    shows: PropTypes.number.required,
    cities: PropTypes.number.required,
    duration: PropTypes.string,
    groups: PropTypes.arrayOf(PropTypes.object).required,
    members: PropTypes.arrayOf(PropTypes.object).required,
    routes: PropTypes.arrayOf(PropTypes.object).required,
    events: PropTypes.arrayOf(PropTypes.object).required,
    notes: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  importRoute: PropTypes.func.isRequired,
  importRoster: PropTypes.func.isRequired,
  removeTourManager: PropTypes.func.isRequired,
  sendToTourManager: PropTypes.func.isRequired,
  clearRoute: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
};
TourOverviewTab.defaultProps = {
  tour: {
    state: 'draft',
    start: null,
    end: null,
    routes: [],
    groups: [],
    members: [],
    events: [],
  },
};
export default TourOverviewTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourOverviewTab.js